import React from "react";
import {useTranslation} from "react-i18next";
import {languages} from "../../language/localesList";
import NavPanel from "../nav-panel";
import {Outlet, useNavigate} from "react-router-dom";
import "./styles.css"

const NavLabel = () => {
    const { i18n, t } = useTranslation();
    const lngs = Object.keys(languages);
    const navigate = useNavigate();

    return (
        <div>
            <div className="nav-panel">
                <div className="nav-background">
                <div className="nav-content">
                    <div className="div2">
                        <div className="div3" onClick={()=>{
                            let nextLngIndex = lngs.findIndex(l => l === i18n.language) + 1;
                            if (nextLngIndex === lngs.length)
                                nextLngIndex = 0;
                            i18n.changeLanguage(lngs[nextLngIndex]);
                        }}>
                            {i18n.language === "ua" &&
                            (<span>
                                <span className="div-3-span">U</span>
                                <span className="div-3-span2">A</span>
                            </span>)}
                            {i18n.language === "ru" &&
                            (<span>
                                <span className="div-3-span" style={{color: "#f10606"}}>R</span>
                                <span className="div-3-span2" style={{color: "#03578b"}}>U</span>
                            </span>)}
                            {i18n.language === "en" &&
                            (<span>
                                <span className="div-3-span">E</span>
                                <span className="div-3-span2" style={{color: "#03578b"}}>N</span>
                            </span>)}
                        </div>
                    </div>
                    <img className="group-187" alt="logo" src="/images/navLogoV2.png" onClick={() => {
                        navigate("/");
                    }}/>
                    <div className="div">
                        <span className="div-span2">{t("NavLabel.HeaderTitle")}</span>
                    </div>
                </div>
                </div>
            </div>
            {/*<NavPanel></NavPanel>*/}
            <Outlet />
            <div className="footer">
            </div>
        </div>
    )
}

export default NavLabel;
